module.exports = __webpack_public_path__ + "media/images/active_material/icons/reorder-04096393cb1ff458c0eedac82b731e7a.svg";